import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaRutas from './TablaRutas';

const Rutas: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaRutas />
    </Box>
  );
};

export default Rutas;
